import { useState, useCallback } from 'react';
import { Alert, Snackbar } from '@mui/material';

// Map legacy 'danger' variant to MUI 'error'
const toMuiSeverity = (type) => (type === 'danger' ? 'error' : type);

const Toast = ({ message, type = 'success', onDismiss }) => {
  const [open, setOpen] = useState(true);

  const handleClose = (_e, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
    onDismiss?.();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert onClose={handleClose} severity={toMuiSeverity(type)} variant="filled" sx={{ minWidth: 300 }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export const useToast = () => {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, type = 'success') => {
    setToast({ message, type, key: Date.now() });
  }, []);

  const ToastContainer = toast ? (
    <Toast
      key={toast.key}
      message={toast.message}
      type={toast.type}
      onDismiss={() => setToast(null)}
    />
  ) : null;

  return { showToast, ToastContainer };
};

export default Toast;
